import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { getAreaChartConfig } from "../../utils/chart-utils";
import * as Highcharts from "highcharts/highstock";
import { Point } from "@models/point";

@Component({
	selector: "area-chart",
	templateUrl: "./area-chart.component.html",
	styleUrls: ["./area-chart.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class AreaChartComponent {
	@Input()
	public set data(data: Point[]) {
		if (data && data.length > 0) {
			this.updateSeries(data);
			this.setYaxisDataRange(data);
		}
	}

	public isChartUpdated: boolean = false;
	public Highcharts: typeof Highcharts = Highcharts;

	public chartOptions: Highcharts.Options = getAreaChartConfig();

	public constructor(protected changeDetectorRef: ChangeDetectorRef) {}

	protected setYaxisDataRange(data: Point[]): void {
		const minY = Math.floor(Math.min(...data.map((d) => d.y))) - 1;
		const maxY = Math.round(Math.max(...data.map((d) => d.y))) + 1;

		this.chartOptions.yAxis[0].min = minY;
		this.chartOptions.yAxis[0].max = maxY;
	}

	protected updateSeries(data: Point[]): void {
		this.chartOptions.series = [
			{
				data: data,
				type: "areaspline"
			}
		];

		// Refresh the view
		this.isChartUpdated = true;
		this.changeDetectorRef.markForCheck();
	}
}
